import { DealtAmtAdapter } from "../../adapter/orderBlotter/DealtAmtAdapter";

import { FixingSourceAdapter } from "../../adapter/common/FixingSourceAdapter";
import { ICellAdapter } from "../../adapter/ICellAdapter";
import { FillAwareOrderTypeAdapter } from "../../adapter/orderBlotter/FillAwareOrderTypeAdapter";
import { ProductAdapter } from "../../adapter/orderBlotter/ProductAdapter";

import { RateAdapter } from "../../adapter/orderBlotter/RateAdapter";
import {
  COLUMN_DEALT_CURRENCY,
  COLUMN_DEALT_DIR,
  COLUMN_INSTRUMENT,
  COLUMN_ORDER_ACTIVATION_DATE,
  COLUMN_ORDER_AMOUNT,
  COLUMN_ORDER_ENTRY_DATE,
  COLUMN_ORDER_EXECUTED_AMOUNT,
  COLUMN_ORDER_EXECUTED_AMOUNT_USD,
  COLUMN_ORDER_EXECUTION_CHANNEL,
  COLUMN_ORDER_EXPIRY_DATE,
  COLUMN_ORDER_FIXING_DATE,
  COLUMN_ORDER_FIXING_SOURCE_CODE,
  COLUMN_ORDER_FWD_DEALT_TRACKING,
  COLUMN_ORDER_MKT_VWAP_ALL_IN,
  COLUMN_ORDER_MKT_VWAP_SPOT,
  COLUMN_ORDER_MONITORING_SIDE,
  COLUMN_ORDER_PRODUCT,
  COLUMN_ORDER_REQUEST_RATE,
  COLUMN_ORDER_STATE,
  COLUMN_ORDER_TYPE,
  COLUMN_ORDER_USD_AMOUNT,
  COLUMN_ORDER_VWAP_ALL_IN,
  COLUMN_ORDER_VWAP_SPOT,
  COLUMN_RATE_SOURCE_CODE,
  COLUMN_REMAINING_AMOUNT,
  COLUMN_REMAINING_AMOUNT_USD,
  COLUMN_REQ_FWD_PTS,
  COLUMN_TRADER_GROUP_NAMES,
  COLUMN_VALUE_DATE,
} from "../../model/OrdersTableDefinitionFactory.constants";

import { Injectable } from "@angular/core";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import {
  PRIMITIVE,
  ServiceMessageBroker,
  ServiceMessageBrokerFactory,
} from "shared/provider-webworker";

import { SysFeatures, SystemConfigPromiseService } from "shared/auth-services";

import { DateAdapter } from "../../adapter/DateAdapter";
import { DealtCcyPairAdapter } from "../../adapter/orderBlotter/DealtCcyPairAdapter";
import { CcyLookupService } from "../../lookup/model/impl/CcyLookupService";
import { CcyPairLookupService } from "../../lookup/model/impl/CcyPairLookupService";
import { ClientLookupService } from "../../lookup/model/impl/ClientLookupService";
import { CubiqWorker } from "../../worker/CubiqWorker";
import { CHANNEL_DETAILED_ORDER_STATUS_REQUEST } from "../IDetailedOrderStatusRequestService";
import { DetailedOrderStatusRequestPromiseService } from "./DetailedOrderStatusRequestPromiseService";

import { OrderStateAdapter } from "../../adapter/orderBlotter/OrderStateAdapter";
import { AccountLookupService } from "../../lookup/model/impl/AccountLookupService";
import { SalesGroupLookupService } from "../../lookup/model/impl/SalesGroupLookupService";
import { TraderGroupLookupService } from "../../lookup/model/impl/TraderGroupLookupService";
import { UserLookupService } from "../../lookup/model/impl/UserLookupService";

import { RateSourceAdapter } from "../../adapter/common/RateSourceAdapter";
import { DealtIntentAdapter } from "../../adapter/orderBlotter/DealtIntentAdapter";
import { EMPTY_RATE_STRING, IFormattedMarkup } from "../../lookup/pricing/PricingService";

import { BasePricingService } from "../../lookup/pricing/impl/BasePricingService";
import { DealtPricingService } from "../../lookup/pricing/impl/DealtPricingService";
import { RateCache } from "../../rate/impl/RateCache";

import { BigNumber } from "shared/cubiq-model-multi-asset";
import { LoggerService } from "@bfx/logger";
import { TranslateService } from "@ngx-translate/core";
import { BfxSysConfigUtilService } from "shared/auth-services";
import { ClientContactImpl, UserImpl } from "shared/cubiq-model-multi-asset";
import { OrderTypeHelper } from "shared/cubiq-services/model/orders/OrderTypeHelper";
import { SuspensionHelper } from "shared/cubiq-services/model/orders/SuspensionHelper";
import { BfxConfigIDRefHelper } from "../../../helper-services/bfx-config-id-ref-helper";
import { FixingTimeAdapter } from "../../adapter/benchmark/FixingTimeAdapter";
import { ExecutedDealtAmtAdapter } from "../../adapter/orderBlotter/ExecutedDealtAmtAdapter";
import { ExpiryAdapter } from "../../adapter/orderBlotter/ExpiryAdapter";
import { FwdTrackingAdapter } from "../../adapter/orderBlotter/FwdTrackingAdapter";
import { NdfFixingDateAdapter } from "../../adapter/orderBlotter/NdfFixingDateAdapter";
import { TenorAdapter } from "../../adapter/orderBlotter/TenorAdapter";
import { TenorValueDateAdapter } from "../../adapter/orderBlotter/TenorValueDateAdapter";
import { TrackingSideAdapter } from "../../adapter/orderBlotter/TrackingSideAdapter";
import { UsdAmtAdapter } from "../../adapter/orderBlotter/UsdAmtAdapter";
import { VwapAdapter } from "../../adapter/orderBlotter/VwapAdapter";
import { StringAdapter } from "../../adapter/StringAdapter";
import { AlgoStrategyLookupService } from "../../lookup/model/impl/AlgoStrategyLookupService";
import { CurrencyPairCalendarLookupService } from "../../lookup/model/impl/CurrencyPairCalendarLookupService";
import { MarketTimeLookupService } from "../../lookup/model/impl/MarketTimeLookupService";
import { RateSourceLookupService } from "../../lookup/model/impl/RateSourceLookupService";
import { ScratchPadDataLookupService } from "../../lookup/model/impl/ScratchPadDataLookupService";
import { SiblingRelationshipManager } from "../../lookup/model/impl/SiblingRelationshipManager";
import { AtdlTooltipUiRep } from "../../model/adtl/atdl-tooltip-ui-rep";
import { BmarkTraderGroupNameHelper } from "../../model/benchmarks/helpers/BmarkTradeGroupNameHelper";
import { OrderPauseState } from "../../model/orders/OrderPauseState";
import { OrdersTableDefinitionFactory } from "../../model/OrdersTableDefinitionFactory";
import { DealPrivatizationService } from "../../model/privatization/DealPrivatizationService";
import { StaticDataPrivatizationType } from "../../model/privatization/enum/StaticDataPrivatizationType";
import { OrderDataPrivatizationService } from "../../model/privatization/OrderDataPrivatizationService";
import { EntryDateAdapter } from "shared/cubiq-services/adapter/EntryDateAdapter";
import { BENCHMARK_TERMINAL_STATE } from "shared/cubiq-services/model/benchmarks/BmarkTerminalState.const";
import { TimezoneLookupService } from "shared/cubiq-services/lookup/model/impl/TimezoneLookupService";
import { ValueDateHelper } from "shared/cubiq-services/model/orders/ValueDateHelper";
import { NullProtoObject } from "shared/helper-services/null-proto-object";
import { default as dateformat } from "dateformat";
export const DATE_FORMAT_SHORT = "DD-MMM-YY";
export const DATE_TIME_FORMAT = "DD-MMM-YY HH:mm:ss";

const CONTACTS_LABEL_SORT: any = (a, b) => {
  return a.contactNameTxt.toLowerCase() < b.contactNameTxt.toLowerCase()
    ? -1
    : a.contactNameTxt.toLowerCase() > b.contactNameTxt.toLowerCase()
      ? 1
      : 0;
};

class StrategyData {
  public x: any;
  public y: any;
  public iY: any;
  public iX: any;

  public childIndex: any;
  public childRelationshipTypes: CubiqTS.OrderRelationshipType[] = [];
  public label: string;
  public id: string;
  public siblingRelationshipType: CubiqTS.OrderRelationshipType;
  public visitorPath: any = [];
}

/**
 * Allocation payload for allocation data after values have been transformed. This transformation should
 * better happen closer to the view at some point in future
 */
export class AllocationInfoDetails {
  allocId: string;
  allocationType: CubiqTS.AllocationType;
  isSpot: boolean;
  allocationRef: string;
  accountCode: string;
  accountName: string;
  instrument: string;
  dir: string;
  dealState: string;
  dealId: string;
  dealRef: string;
  dealtCcy: string;
  baseCcy: string;
  nonbaseCcy: string;
  orderAmt: string;
  marketSpot: string;
  marketPts: string;
  marketAllIn: string;
  clientSpot: string;
  clientPts: string;
  clientAllIn: string;
  counterAmt: string;
  markup: string;
  fillDate: string;
  valueDt: string;
  traderGroup: string;
  reqFwdPoints: string;
  rawValues: AllocationInfoRawDetails;
  npvAmt: string;
  npvCounterAmt: string;
}

/**
 * Allocation payload for raw allocation data used for sorting
 */
export class AllocationInfoRawDetails {
  orderAmt: CubiqTS.BigNumber;
  marketSpot: CubiqTS.BigNumber;
  marketPts: CubiqTS.BigNumber;
  marketAllIn: CubiqTS.BigNumber;
  clientSpot: CubiqTS.BigNumber;
  clientPts: CubiqTS.BigNumber;
  clientAllIn: CubiqTS.BigNumber;
  counterAmt: CubiqTS.BigNumber;
  markup: CubiqTS.BigNumber;
  fillDate: CubiqTS.Moment;
  valueDt: CubiqTS.Moment;
  reqFwdPoints: CubiqTS.BigNumber;
  npvAmt: CubiqTS.BigNumber;
  npvCounterAmt: CubiqTS.BigNumber;
}

const logger = LoggerService.for(__dirname);

@Injectable()
export class DetailedOrderStatusRequestPrimaryService extends DetailedOrderStatusRequestPromiseService {
  protected ready: Promise<void>;
  protected broker: ServiceMessageBroker;
  private orderStateAdapter: OrderStateAdapter = new OrderStateAdapter(this.translateService);
  private dateAdapter: ICellAdapter = new DateAdapter();
  private entryDateAdapter: ICellAdapter = new EntryDateAdapter(); // doesn't UTC base the value
  private dealtCcyPairAdapter: ICellAdapter = new DealtCcyPairAdapter();

  private bmTraderGroupNameHelper: BmarkTraderGroupNameHelper;
  private rateAdapter: RateAdapter;
  private dealtIntentAdapter: DealtIntentAdapter = new DealtIntentAdapter();
  private typeAdapter: FillAwareOrderTypeAdapter;
  private productAdapter: ProductAdapter;

  private dealtVwapAdapter: ICellAdapter;
  private leavesQtyAdapter: ICellAdapter;
  private executedAmtAdapter: ICellAdapter;
  private expiryDtsAdapter: ICellAdapter;
  private dealtAmtAdapter: ICellAdapter;

  private trackingSideAdapter: ICellAdapter;

  private usdAmtAdapter: UsdAmtAdapter;
  private dealtCcyAdapter: ICellAdapter;
  private rateSourceAdapter: ICellAdapter;

  private fixingSourceAdapter: FixingSourceAdapter;
  private fixingDateAdapter: NdfFixingDateAdapter = new NdfFixingDateAdapter(
    this.currencyPairCalendarLookupService,
  );
  private fixingTimeAdapter: FixingTimeAdapter = new FixingTimeAdapter("HH:mm", true, true);

  private fwdTrackingAdapter: ICellAdapter;
  private valueDateAdapter: TenorValueDateAdapter = new TenorValueDateAdapter(
    this.currencyPairCalendarLookupService,
  );
  private tenorAdapter: TenorAdapter = new TenorAdapter();
  protected myPartFillDisabledTypeText: string = "";

  private adaptedMap: Map<string, CubiqTS.OrderDataImpl> = new Map();
  private orderIdRequestRefMap: Map<string, string[]> = new Map();

  private adaptedCount: number = 0;

  private siblingRelationshipManager: SiblingRelationshipManager;

  private suspensionHelper: SuspensionHelper;

  constructor(
    private worker: CubiqWorker,
    protected factory: ServiceMessageBrokerFactory,
    private rateCache: RateCache,
    private ccyLookupService: CcyLookupService,
    private ccyPairLookupService: CcyPairLookupService,
    private clientPromiseLookup: ClientLookupService,
    private salesGroupLookup: SalesGroupLookupService,
    private traderGroupLookup: TraderGroupLookupService,
    private accountLookupService: AccountLookupService,
    private userLookupService: UserLookupService,
    tdf: OrdersTableDefinitionFactory,
    protected algoStrategyLookupService: AlgoStrategyLookupService,
    protected sysConfigService: SystemConfigPromiseService,
    protected rateSourceLookup: RateSourceLookupService,
    private myBasePricingService: BasePricingService,
    private myDealtPricingService: DealtPricingService,
    private translateService: TranslateService,
    private marketTimeLookup: MarketTimeLookupService,
    private orderDataPrivatizationService: OrderDataPrivatizationService,
    private dealPrivatizationService: DealPrivatizationService,
    protected currencyPairCalendarLookupService: CurrencyPairCalendarLookupService,
    private scratchpadLookupService: ScratchPadDataLookupService,
    protected tooltipUiRep: AtdlTooltipUiRep,
    protected sysConfigUtilService: BfxSysConfigUtilService,
    protected timeZoneService: TimezoneLookupService,
  ) {
    super();

    this.rateAdapter = new RateAdapter(this.myDealtPricingService, true);
    this.fixingSourceAdapter = new FixingSourceAdapter(this.translateService);

    this.broker = factory.createMessageBroker(CHANNEL_DETAILED_ORDER_STATUS_REQUEST, true, true);

    this.broker.registerMethod(
      "request",
      [PRIMITIVE],
      this.request.bind(this),
      CubiqTS.ENCODABLE(CubiqTS.OrderDataImpl),
    );

    this.broker.registerMethod(
      "requestMediatedOrderDetails",
      [PRIMITIVE],
      this.requestMediatedOrderDetails.bind(this),
      PRIMITIVE,
    );

    this.broker.registerMethod(
      "releaseMediatedOrderDetails",
      [PRIMITIVE],
      this.releaseMediatedOrderDetails.bind(this),
      PRIMITIVE,
    );

    this.broker.registerMethod(
      "getMediatedOrderData",
      [PRIMITIVE, PRIMITIVE],
      this.getMediatedOrderData.bind(this),
      CubiqTS.ENCODABLE(CubiqTS.OrderDataImpl),
    );

    this.sysConfigService
      .getSystemConfig(SysFeatures.partFillDisabledTypeText)
      .then((partFillDisabledTypeText) => {
        this.myPartFillDisabledTypeText = partFillDisabledTypeText ? partFillDisabledTypeText : "";
      });

    this.ready = new Promise<void>((res, rej) => {
      this.initTableDefinition(tdf, res, rej);
    });
    this.siblingRelationshipManager = new SiblingRelationshipManager();
    this.suspensionHelper = new SuspensionHelper();
  }

  public initTableDefinition(tdf: OrdersTableDefinitionFactory, resReady, rejReady): void {
    let tableDefinitionPromise = tdf.defineTable();

    tableDefinitionPromise.then(
      (td) => {
        this.typeAdapter = new FillAwareOrderTypeAdapter(
          this.myPartFillDisabledTypeText,
          this.algoStrategyLookupService,
          this.sysConfigService,
          this.sysConfigUtilService,
        );

        this.productAdapter = new ProductAdapter();

        this.dealtVwapAdapter = new VwapAdapter(this.myDealtPricingService, true);

        this.leavesQtyAdapter = new DealtAmtAdapter(this.ccyLookupService);

        this.executedAmtAdapter = new ExecutedDealtAmtAdapter(this.ccyLookupService);

        this.expiryDtsAdapter = new ExpiryAdapter();

        this.dealtAmtAdapter = new DealtAmtAdapter(this.ccyLookupService);

        this.usdAmtAdapter = new UsdAmtAdapter(this.ccyLookupService);

        this.dealtCcyAdapter = new StringAdapter();

        this.trackingSideAdapter = new TrackingSideAdapter(
          this.myDealtPricingService,
          this.translateService,
        );

        this.rateSourceAdapter = new RateSourceAdapter(this.rateSourceLookup);

        this.fwdTrackingAdapter = new FwdTrackingAdapter(this.myDealtPricingService, true);

        this.bmTraderGroupNameHelper = new BmarkTraderGroupNameHelper(
          this.traderGroupLookup,
          COLUMN_TRADER_GROUP_NAMES,
        );

        resReady();
      },
      (err) => {
        logger.out.error(
          `DetailedOrderStatusRequestPrimaryService: Failed to resolve Table Definition: ${err}`,
        );
        rejReady();
      },
    );
  }

  public request(id: string): Promise<CubiqTS.OrderDataImpl> {
    let request = new CubiqTS.DetailedOrderStatusRequestImpl();

    request.orderId = id;

    return new Promise<CubiqTS.OrderDataImpl>((resolve, reject) => {
      logger.out.info(`Detailed Order Status report for Order Id ${id} requested.`);

      Promise.all([this.worker.postServiceRequest(request), this.ready]).then(
        (values: any[]) => {
          let value = values[0];

          if (value instanceof CubiqTS.ErrorsImpl) {
            if (Array.isArray(value.errorMessages) && value.errorMessages.length > 0)
              reject(value.errorMessages[0]);

            reject(`orddet.error`);
            return;
          }

          if (value && Array.isArray(value.results)) {
            this.preprocessOrderDataResults(value.results);

            if (value.results[0].gammaRungId) {
              let gammaData = this.parseGammaData(value.results, id);
              if (gammaData.firstOrder != null) {
                let first: CubiqTS.OrderDataImpl = gammaData.firstOrder;
                first.strategyType = gammaData.strategyType;
              }
            }

            let orderData: CubiqTS.OrderDataImpl = value.results[0];

            logger.out.info(`Detailed Order Status report for Order Id ${id} received.`);

            resolve(orderData);
          }

          reject(`orddet.error`);
        },
        (reason) => {
          reject(reason);
        },
      );
    });
  }

  /**
   * Return trade deals for multiple orders - multiple is useful for strategies and Gammas
   *
   * @param ids
   * @returns
   */
  public requestAdaptedTradeDeals(ids: Array<string>): Promise<any> {
    return new Promise<Array<any>>((resolve, reject) => {
      const idStr = ids.join(", ");
      let tradeStatusRequest = new CubiqTS.TradeStatusRequestImpl();

      tradeStatusRequest.orderIds = ids.map((orderId) => CubiqTS.Long.fromString(orderId));
      tradeStatusRequest.orderTypes = null;

      logger.out.info(`Trade Status report for Order Id ${idStr} requested.`);

      Promise.all([this.worker.postServiceRequest(tradeStatusRequest), this.ready]).then(
        (values: any[]) => {
          let value: CubiqTS.StandardReportImpl = values[0] as CubiqTS.StandardReportImpl;
          let adaptedTradeDeal = [];

          if (value instanceof CubiqTS.ErrorsImpl) {
            if (Array.isArray(value.errorMessages) && value.errorMessages.length > 0)
              reject(value.errorMessages[0]);

            reject(`orddet.error`);
            return;
          }

          if (value && Array.isArray(value.results)) {
            adaptedTradeDeal = value.results.map((d) =>
              this.dealPrivatizationService.checkPrivatization(d),
            );
            logger.out.info(`Trade Status report for Order Id ${idStr} adapt in progress.`);
          }

          resolve(adaptedTradeDeal);
        },
        (reason) => {
          resolve(reason);
        },
      );
    });
  }

  public requestMediatedOrderDetails(id: string): Promise<any> {
    let request = new CubiqTS.DetailedOrderStatusRequestImpl();

    request.orderId = id;

    this.adaptedCount++;

    return new Promise<CubiqTS.OrderDataImpl>((resolve, reject) => {
      Promise.all([this.worker.postServiceRequest(request), this.ready]).then(
        (values: any[]) => {
          let value: CubiqTS.StandardReportImpl = values[0] as CubiqTS.StandardReportImpl;

          if (value instanceof CubiqTS.ErrorsImpl) {
            reject(value.errorMessages[0]);
            return;
          }

          if (value && Array.isArray(value.results) && value.results.length > 0) {
            this.preprocessOrderDataResults(value.results);

            let payload;
            if (value.results[0].gammaRungId) {
              payload = this.parseGammaData(value.results, id);
            } else {
              let rootOrderData: CubiqTS.OrderDataImpl = value.results[0];
              payload = this.parseStrategyData(rootOrderData);
            }
            resolve(payload);
          } else {
            reject(`orddet.error`);
          }
        },
        (reason) => {
          reject(reason);
        },
      );
    });
  }

  /**
   * if a single DetailedOrderStatusRequestImpl results in a multiple order response
   * a sibling relationship exists which must be sorted to re-establish root order
   *
   * this is an in-place operation
   *
   * @param orderData
   * @returns void
   */
  public preprocessOrderDataResults(orderData: CubiqTS.OrderDataImpl[]): void {
    if (Array.isArray(orderData)) {
      orderData.sort((a, b) => {
        if (
          a != null &&
          a instanceof CubiqTS.OrderDataImpl &&
          b != null &&
          b instanceof CubiqTS.OrderDataImpl &&
          CubiqTS.Long.isLong(a.orderId) &&
          CubiqTS.Long.isLong(b.orderId)
        ) {
          return a.orderId.compare(b.orderId);
        } else {
          return 0;
        }
      });
      orderData.forEach((o, i, arr) => {
        arr[i] = this.preprocessOrderData(o, true);
      });
    }
  }

  /**
   * see preprocessOrderData()
   *
   * this is an in-place operation
   *
   * @param orderData
   * @param checkSibling
   * @returns
   */
  private preprocessOrderData(
    orderData: CubiqTS.OrderDataImpl,
    checkSibling: boolean = true,
  ): CubiqTS.OrderDataImpl {
    orderData = this.orderDataPrivatizationService.checkPrivatization(orderData);

    if (orderData.childRelationships != null) {
      orderData.childRelationships = orderData.childRelationships.sort(
        (a: CubiqTS.Relationship, b: CubiqTS.Relationship) => {
          return new BigNumber(a.orderId).comparedTo(new BigNumber(b.orderId));
        },
      );

      orderData.childRelationships.forEach((r: CubiqTS.Relationship) => {
        if (r.order != null) {
          r.order = this.preprocessOrderData(r.order);
        }
      });
    }

    if (
      checkSibling &&
      orderData.siblingRelationship != null &&
      orderData.siblingRelationship.order != null
    ) {
      orderData.siblingRelationship.order = this.preprocessOrderData(
        orderData.siblingRelationship.order,
        false,
      );
    }

    if (orderData.orderState == CubiqTS.OrderState.SAVED) {
      this.preprocessSavedOrderData(orderData);
    }

    return orderData;
  }

  /**
   * Order data for saved order is not going to contain trader group as it
   * is only available as a requested trader group. However if part of scratchpad
   * the modification request will contain it and it will be primed so we try to
   * get it from there as we will need it for modification.
   */
  private preprocessSavedOrderData(orderData: CubiqTS.OrderDataImpl): void {
    if (orderData.deskId == null && orderData.clOrdID != null) {
      try {
        orderData.deskId = this.scratchpadLookupService.getTraderGroupId(orderData.clOrdID);
      } catch (e) {
        logger.out.warn("Failed to retrieve trader group id for order data: ", orderData, e);
      }
    }
  }

  private parseOrderDetails(orderData: CubiqTS.OrderDataImpl, root: CubiqTS.OrderDataImpl): any {
    let orderDetails: any = {};

    orderDetails["orderData"] = orderData;
    orderDetails["clientBranch"] = orderData.clientBranchCode;

    // Client info
    let client: CubiqTS.ClientImpl = null;
    if (
      orderData.counterPartyDetails &&
      orderData.counterPartyDetails.client instanceof CubiqTS.ClientImpl
    ) {
      client = orderData.counterPartyDetails.client;
    } else if (orderData.orderType === CubiqTS.OrderType.BENCHMARK) {
      client = this.clientPromiseLookup.getClient(orderData.clientCode);
    }

    if (client != null) {
      orderDetails["clientId"] = client.clientId;
      orderDetails["clientName"] = client.clientName;
    } else {
      orderDetails["clientId"] = orderData.clientCode;
      orderDetails["clientName"] = orderData.clientName;
    }

    let salesGroup: CubiqTS.SalesGroupImpl = this.salesGroupLookup.getSalesGroup(
      orderData.salesGroupId,
    );
    if (salesGroup != null) {
      orderDetails["clientSalesGroup"] = salesGroup.groupCode;
    }

    // Account info
    let account: CubiqTS.AccountImpl = null;
    if (
      orderData.counterPartyDetails &&
      orderData.counterPartyDetails.account instanceof CubiqTS.AccountImpl
    ) {
      account = orderData.counterPartyDetails.account;
    } else if (orderData.orderType === CubiqTS.OrderType.BENCHMARK) {
      account = this.accountLookupService.getAccount(orderData.accountCode);
    }

    if (account != null) {
      orderDetails["accountId"] = account.id;
      orderDetails["accountName"] = account.name;
      orderDetails["accountBookingCd"] = account.bookingCode;
      orderDetails["accountContact"] = account.contact;
    } else {
      orderDetails["accountId"] = orderData.accountCode;
      orderDetails["accountName"] = orderData.accountName;
      orderDetails["accountBookingCd"] = "";
      orderDetails["accountContact"] = "";
    }

    orderDetails["contacts"] = ``;

    if (
      !StaticDataPrivatizationType.hasPrivatization(orderData) &&
      orderData.clientContactIds != null &&
      orderData.clientContactIds.length > 0
    ) {
      let contactsNames: Array<string> = [];
      let contacts: Array<CubiqTS.ClientContactImpl> = [];

      orderData.clientContactIds.forEach((id: CubiqTS.Long) => {
        let clientContact: ClientContactImpl = this.clientPromiseLookup.getClientContact(
          id.toString(),
        );
        if (clientContact != null) {
          contactsNames.push(clientContact.contactNameTxt);
          contacts.push(this.createClientContactObject(clientContact));
        }
      });

      orderDetails["contacts"] = contacts
        .sort(CONTACTS_LABEL_SORT)
        .map((contact: any) => contact.contactNameTxt)
        .join(",");
      if (contacts.length > 0) {
        orderDetails["contactData"] = JSON.stringify(contacts);
      } else {
        orderDetails["contactData"] = null;
      }
    } else if (
      Array.isArray(orderData.clientContactIds) &&
      orderData.counterPartyDetails &&
      Array.isArray(orderData.counterPartyDetails.contacts)
    ) {
      let contactsNames: Array<string> = [];
      let contacts: Array<CubiqTS.ClientContactImpl> = [];

      orderData.clientContactIds.forEach((id: CubiqTS.Long) => {
        let clientContact: ClientContactImpl = orderData.counterPartyDetails.contacts.find(
          (contact) => {
            if (!(contact instanceof ClientContactImpl)) return false;

            return id.equals(contact.id);
          },
        );

        if (clientContact != null) {
          contactsNames.push(clientContact.contactNameTxt);
          contacts.push(this.createClientContactObject(clientContact));
        }
      });

      orderDetails["contacts"] = contacts
        .sort(CONTACTS_LABEL_SORT)
        .map((contact: any) => contact.contactNameTxt)
        .join(",");
      if (contacts.length > 0) {
        orderDetails["contactData"] = JSON.stringify(contacts);
      } else {
        orderDetails["contactData"] = null;
      }
    }

    orderDetails["clientTrader"] = orderData.clientTraderName;
    if (OrderPauseState.isPausedOrderState(orderData)) {
      orderDetails["state"] = this.translateService.instant("order.state.PAUSED");
    } else {
      orderDetails["state"] = this.orderStateAdapter.retrieveData(orderData, COLUMN_ORDER_STATE);
    }

    orderDetails["traderGroup"] = this.adaptTraderGroup(orderData);

    // if (orderData.deskId) {
    //     orderDetails['traderGroup'] = this.traderGroupLookup.getItem(orderData.deskId.toString()).groupCode;
    // }

    // if (orderData.hasOwnProperty('allocationData') && orderData.allocationData[0].deskId) {
    //   orderDetails['traderGroup'] = this.benchmarkTradeGroupAdapter.retrieveData(orderData, COLUMN_DESK_ID);
    // }

    if (orderData.targetDeskId) {
      orderDetails["targetGroup"] = this.traderGroupLookup.getItem(
        orderData.targetDeskId.toString(),
      ).groupCode;
    }

    if (orderData.orderId) orderDetails["orderId"] = orderData.orderId.toString();

    if (orderData.orderRef) orderDetails["orderRef"] = orderData.orderRef;

    if (orderData.strategyId) orderDetails["strategyId"] = orderData.strategyId.toString();

    if (orderData.strategyRef) orderDetails["strategyRef"] = orderData.strategyRef.toString();

    // Strategy Parameters
    if (Array.isArray(orderData.strategyParameters)) {
      orderDetails["strategyParameters"] = this.tooltipUiRep.inlineUiRep(
        orderData.algoStrategyName,
        orderData.strategyParameters,
      );
    }
    // PassThrough Parameters
    orderDetails["hasPassThroughParameters"] = false;
    if (
      Array.isArray(orderData.passthroughParameters) &&
      orderData.passthroughParameters.length > 0
    ) {
      orderDetails["passThroughParameters"] = this.tooltipUiRep.inlineUiRep(
        "Pass Through Parameters",
        orderData.passthroughParameters,
      );
      orderDetails["hasPassThroughParameters"] = true;
    }

    orderDetails["clOrderId"] = orderData.clOrdID;

    orderDetails["entryChannel"] = orderData.channelCd;

    orderDetails["entryDate"] = this.entryDateAdapter.retrieveData(
      orderData,
      COLUMN_ORDER_ENTRY_DATE,
    );
    orderDetails["entryUser"] = orderData.entryUserCode;

    // Entry user info
    if (orderData.entryUserCode != null) {
      let user: UserImpl = this.userLookupService.getUser(orderData.entryUserCode);
      if (user != null) {
        orderDetails["entryUser"] = user.userName;
        orderDetails["entryUserCode"] = user.userCode;
        orderDetails["entryUserId"] = user.userId.toString();
        orderDetails["entryUserBranch"] = user.branchCode;
        orderDetails["entryUserType"] = user.userType;
      }
    }
    // added for order details summary - start
    // check if has allocations
    if (orderData.hasOwnProperty("allocationData") && orderData.allocationData[0]) {
      let allocationData = orderData.allocationData[0];
      orderDetails["dealtCcy"] = allocationData.fixedCcy ? allocationData.fixedCcy : "";
    } else {
      orderDetails["dealtCcy"] = orderData.fixedCode != null ? orderData.fixedCode : "";
    }

    orderDetails["requestedOrderType"] =
      orderData.requestedOrderType != null ? orderData.requestedOrderType : null;
    // end

    orderDetails["instrument"] = this.dealtCcyPairAdapter.retrieveData(
      orderData,
      COLUMN_INSTRUMENT,
    );

    orderDetails["dir"] = this.dealtIntentAdapter.retrieveSearch(orderData, COLUMN_DEALT_DIR);

    // orderDetails['dealState'] = this.benchmarkDealStateAdapter.retrieveData(orderData, 'dealState');

    // orderDetails['dealStateId'] = this.findDealStateAdapter.retrieveData(orderData, 'dealState');

    orderDetails["inflightChecks"] = "None";

    if (orderData.inflightInclusionState === CubiqTS.InflightInclusionState.ENABLED) {
      orderDetails["inflightChecks"] = "Enabled";
    } else if (orderData.inflightInclusionState === CubiqTS.InflightInclusionState.DISABLED) {
      orderDetails["inflightChecks"] = "Disabled";
    }

    let requestRate = this.rateAdapter.retrieveData(orderData, COLUMN_ORDER_REQUEST_RATE);
    requestRate
      ? (orderDetails["requestRt"] = requestRate)
      : (orderDetails["requestRt"] = EMPTY_RATE_STRING);

    orderDetails["type"] = this.typeAdapter.retrieveData(orderData, COLUMN_ORDER_TYPE, false);
    orderDetails["isAlgoOrder"] = orderData.orderType === CubiqTS.OrderType.ALGO;
    orderDetails["isBenchmarkOrder"] = orderData.orderType === CubiqTS.OrderType.BENCHMARK;
    orderDetails["isBenchmarkClientOrder"] =
      orderData.orderType === CubiqTS.OrderType.BENCHMARK &&
      orderData.fixingDetails.bmOrderType !== CubiqTS.BenchmarkOrderType.PositionOrder;
    orderDetails["isBenchmarkHedgeOrder"] =
      orderData.orderType === CubiqTS.OrderType.BENCHMARK &&
      orderData.fixingDetails.bmOrderType === CubiqTS.BenchmarkOrderType.PositionOrder;
    orderDetails["isBenchmarkAlgoOrder"] = orderData.orderType === CubiqTS.OrderType.BMALGO;
    orderDetails["isMKTOrder"] =
      CubiqTS.OrderType.MARKET === orderData.orderType ||
      CubiqTS.OrderType.MARKET_FOK === orderData.orderType ||
      CubiqTS.OrderType.MARKET_IOC === orderData.orderType;
    orderDetails["isGamma"] = orderData.gammaRungId;
    orderDetails["isLimit"] =
      orderData.orderType === CubiqTS.OrderType.LIMIT_TP ||
      orderData.orderType === CubiqTS.OrderType.LIMIT_SL;

    if (orderDetails["isBenchmarkHedgeOrder"]) {
      orderDetails["type"] = "BMHO";
    }

    // Trigger
    if (
      orderData.requestTrackingType !== null &&
      typeof orderData.requestTrackingType !== "undefined"
    ) {
      if (orderData.requestTrackingType == CubiqTS.RequestTrackingType.SPOT_RATE) {
        orderDetails["trigger"] = "Spot";
      } else if (orderData.requestTrackingType == CubiqTS.RequestTrackingType.OUTRIGHT_RATE) {
        orderDetails["trigger"] = "Outright";
      }
    }

    orderDetails["product"] = this.productAdapter.retrieveData(orderData, COLUMN_ORDER_PRODUCT);

    // Value Date
    const hasTenor = orderData.settleTenor !== undefined && orderData.settleTenor !== null;
    let tenorStr = this.tenorAdapter.retrieveData(orderData, COLUMN_VALUE_DATE);
    let tenorDate =
      orderData.orderType == CubiqTS.OrderType.BENCHMARK && orderData.settleDate
        ? (hasTenor ? tenorStr + " (" : "") +
          orderData.settleDate.utc().format("DD-MMM-YYYY") +
          (hasTenor ? ")" : "")
        : this.valueDateAdapter.retrieveData(orderData, COLUMN_VALUE_DATE);

    if (
      (BENCHMARK_TERMINAL_STATE.has(orderData.orderState) ||
        orderData.orderState === CubiqTS.OrderState.PENDING_FWDS ||
        orderData.orderState === CubiqTS.OrderState.CANCEL_PENDING_FWDS ||
        orderData.orderState === CubiqTS.OrderState.EXPIRY_PENDING_FWDS) &&
      orderData.settleDate != null
    ) {
      tenorDate = `${tenorStr} (${orderData.settleDate.utc().format("DD-MMM-YYYY")})`;
    }

    if (ValueDateHelper.isCanceledOrExpiredNotPartFilledAlgo(orderData)) {
      tenorDate = tenorStr;
    }

    orderDetails["tenor"] = tenorStr ? tenorStr : "";

    orderDetails["valueDt"] = tenorDate ? tenorDate : orderDetails["tenor"];

    orderDetails["orderAmt"] =
      (this.dealtAmtAdapter as DealtAmtAdapter).retrieveDetails(orderData, COLUMN_ORDER_AMOUNT) +
      " ";
    if (orderData.requestedOrderType !== CubiqTS.RequestOrderType.CALL) {
      orderDetails["orderAmt"] +=
        orderData.hasOwnProperty("allocationData") && orderData.allocationData[0]
          ? orderData.allocationData[0].fixedCcy
          : (this.dealtCcyAdapter as DealtAmtAdapter).retrieveData(
              orderData,
              COLUMN_DEALT_CURRENCY,
            );
    }

    orderDetails["orderAmtUsd"] = `${this.usdAmtAdapter.retrieveDetails(
      orderData,
      COLUMN_ORDER_USD_AMOUNT,
    )} USD`;

    orderDetails["orderAmtUsdInvalid"] = orderDetails["orderAmtUsd"] === `- USD`;

    orderDetails["openAmt"] =
      (this.leavesQtyAdapter as DealtAmtAdapter).retrieveDetails(
        orderData,
        COLUMN_REMAINING_AMOUNT,
      ) + " ";

    if (orderData.requestedOrderType !== CubiqTS.RequestOrderType.CALL) {
      orderDetails["openAmt"] +=
        orderData.hasOwnProperty("allocationData") && orderData.allocationData[0]
          ? orderData.allocationData[0].fixedCcy
          : (this.dealtCcyAdapter as DealtAmtAdapter).retrieveData(
              orderData,
              COLUMN_DEALT_CURRENCY,
            );
    }

    orderDetails["openAmtUsd"] = `${this.usdAmtAdapter.retrieveData(
      orderData,
      COLUMN_REMAINING_AMOUNT_USD,
    )} USD`;

    orderDetails["openAmtUsdInvalid"] = orderDetails["openAmtUsd"] === `- USD`;

    orderDetails["oddFixingDateFg"] = orderData.isOddFixingDateFg;

    orderDetails["fillAmt"] = (this.executedAmtAdapter as DealtAmtAdapter).retrieveDetails(
      orderData,
      COLUMN_ORDER_EXECUTED_AMOUNT,
    );
    if (orderDetails["fillAmt"] != EMPTY_RATE_STRING) {
      orderDetails["fillAmt"] +=
        " " +
        (this.dealtCcyAdapter as DealtAmtAdapter).retrieveData(orderData, COLUMN_DEALT_CURRENCY);
    }
    orderDetails["fillAmtUsd"] = `${this.usdAmtAdapter.retrieveData(
      orderData,
      COLUMN_ORDER_EXECUTED_AMOUNT_USD,
    )} USD`;
    orderDetails["fillAmtUsdInvalid"] = orderDetails["fillAmtUsd"] === `- USD`;

    orderDetails["fixingCode"] = this.fixingSourceAdapter.retrieveData(
      orderData,
      COLUMN_ORDER_FIXING_SOURCE_CODE,
    );

    orderDetails["oboClient"] = orderData.oboClient != null ? orderData.oboClient : "-";
    orderDetails["oboAccount"] = orderData.oboAccount != null ? orderData.oboAccount : "-";
    orderDetails["oboEntryUser"] = orderData.oboEntryUser != null ? orderData.oboEntryUser : "-";

    if (
      orderData.orderType === CubiqTS.OrderType.BENCHMARK ||
      orderData.orderType === CubiqTS.OrderType.BMALGO
    ) {
      orderDetails["fixingDateUtc"] = this.fixingTimeAdapter.retrieveData(
        orderData,
        "fixingTimeUTC",
      );
    }

    if (orderData.orderType === CubiqTS.OrderType.BMALGO) {
      orderDetails["algoProfile"] = orderData.algoProfileId;
    }

    if (orderData.orderType === CubiqTS.OrderType.BMALGO) {
      if (orderData.fixingDate instanceof Object) {
        let timeFormat = "HH:mm";
        let dateFormat = "DD-MMM-YY";
        let zone = CubiqTS.moment.tz(CubiqTS.moment.tz.guess()).format("z");
        orderDetails["fixingDate"] =
          orderData.fixingDate.format(timeFormat) +
          " " +
          zone +
          " " +
          orderData.fixingDate.format(dateFormat);
      } else {
        logger.out.error(`Invalid fixingDate for BMALGO`);
        orderDetails["fixingDate"] = EMPTY_RATE_STRING;
      }
    } else {
      orderDetails["fixingDate"] = this.fixingDateAdapter.retrieveData(
        orderData,
        COLUMN_ORDER_FIXING_DATE,
      );
    }

    let fwdPts = this.myDealtPricingService.getDealtFormatedFwdPts(orderData);
    orderDetails["forwardPts"] = fwdPts ? fwdPts : EMPTY_RATE_STRING;

    let fwdTrackingValue = this.fwdTrackingAdapter.retrieveData(
      orderData,
      COLUMN_ORDER_FWD_DEALT_TRACKING,
    );
    orderDetails["forwardTracking"] = fwdTrackingValue ? fwdTrackingValue : EMPTY_RATE_STRING;

    let pricingService = this.myDealtPricingService;
    orderDetails["avgPx"] = this.dealtVwapAdapter.retrieveData(orderData, COLUMN_ORDER_VWAP_ALL_IN);
    orderDetails["avgMktSpot"] = pricingService.getVwap(orderData, COLUMN_ORDER_MKT_VWAP_SPOT);
    orderDetails["avgClientSpot"] = pricingService.getVwap(orderData, COLUMN_ORDER_VWAP_SPOT);
    orderDetails["avgMarketPoints"] = pricingService.getMarketVwapPoints(orderData);
    orderDetails["avgClientPoints"] = pricingService.getClientVwapPoints(orderData);
    orderDetails["avgMktAllIn"] = pricingService.getVwap(orderData, COLUMN_ORDER_MKT_VWAP_ALL_IN);

    let activationDts = orderData.activationDts;
    if (activationDts == null) {
      activationDts = orderData.entryDts;
    }
    let goodFrom = "-";
    if (activationDts != null) {
      goodFrom = activationDts.local().format("DD-MMM-YY HH:mm:ss");
    }
    orderDetails["goodFrom"] = goodFrom;

    let goodUntil = "-";
    let expirationDts = orderData.expiryDts;
    if (orderData.expiryType == CubiqTS.OrderExpiryType.GTC) {
      goodUntil = "GTC";
    } else if (expirationDts != null) {
      goodUntil = expirationDts.local().format("DD-MMM-YY HH:mm:ss");
    }
    orderDetails["goodUntil"] = goodUntil;

    // GoodFrom details
    let goodFromDetails = null;
    if (
      orderData.activationDetails != null &&
      orderData.activationDetails.activationTime != null &&
      orderData.activationDetails.activationDate != null &&
      orderData.activationDetails.timezone != null
    ) {
      let time = orderData.activationDetails.activationTime;
      let hours = time.slice(0, 2);
      let minutes = time.slice(2, 4);
      let seconds = time.slice(4);
      let inputDatetime: string =
        orderData.activationDetails.activationDate +
        " " +
        hours +
        ":" +
        minutes +
        (seconds != null && seconds.length > 0 ? ":" + seconds : "");
      let momentValue = CubiqTS.moment(inputDatetime, "YYYY-MM-DD HH:mm:ss");
      if (momentValue.isValid()) {
        goodFromDetails =
          momentValue.format("DD-MMM-YYYY HH:mm:ss") + " " + orderData.activationDetails.timezone;
      }
    } else if (orderData.activationAlias != null) {
      goodFromDetails = this.resolveMarketTimeConstToDisplay(orderData.activationAlias);
    }
    orderDetails["goodFromDetails"] = goodFromDetails;

    // GoodUntil details
    let goodUntilDetails = null;
    if (
      orderData.expiryDetails != null &&
      orderData.expiryDetails.expiryTime != null &&
      orderData.expiryDetails.expiryDate != null &&
      orderData.expiryDetails.timezone != null
    ) {
      let time = orderData.expiryDetails.expiryTime;
      let hours = time.slice(0, 2);
      let minutes = time.slice(2, 4);
      let seconds = time.slice(4);
      let inputDatetime: string =
        orderData.expiryDetails.expiryDate +
        " " +
        hours +
        ":" +
        minutes +
        (seconds != null && seconds.length > 0 ? ":" + seconds : "");

      let adaptedTimezone = orderData.expiryDetails.timezone;
      if (adaptedTimezone != null) {
        try {
          let timeZone = this.timeZoneService.getTimezone(adaptedTimezone);
          if (timeZone != null) {
            adaptedTimezone = timeZone.javaTimeZoneCd;
          }
        } catch (e) {
          logger.out.warn(`${this.constructor.name}: Failed to convert good until time zone ${e}`);
        }
      }

      let momentValue: CubiqTS.Moment = CubiqTS.moment.tz(
        inputDatetime,
        "YYYY-MM-DD HH:mm:ss",
        adaptedTimezone,
      );

      if (orderData.expiryDts != null && orderData.expiryDetails.dayOrder === true) {
        momentValue = orderData.expiryDts.clone().tz(adaptedTimezone);
      }

      if (momentValue.isValid()) {
        if (
          orderData.expiryDetails.dayOrder === true &&
          orderData.expiryDetails.timezone === "UTC"
        ) {
          // NB PATCH - this is a temporary fix until the server starts to resolve DAY orders to the timezone of the Trade Date Roll - currenrly resolves em all to UTC
          momentValue = momentValue.local();
          goodUntilDetails = dateformat(momentValue.toDate(), "dd-mmm-yyyy HH:MM:ss (Z)");
        } else {
          goodUntilDetails =
            momentValue.format("DD-MMM-YYYY HH:mm:ss") + " " + orderData.expiryDetails.timezone;
        }
      }
    } else if (orderData.expiryAlias != null) {
      goodUntilDetails = this.resolveMarketTimeConstToDisplay(orderData.expiryAlias);
    }
    orderDetails["goodUntilDetails"] = goodUntilDetails;

    let suspend = this.suspensionHelper.getSuspensionDescription(orderData, false);
    orderDetails["suspend"] = suspend;

    if (orderData.isPrivate) {
      orderDetails["private"] = `Yes`;
    } else {
      orderDetails["private"] = `No`;
    }

    // TODO
    if (orderData.stpHold) {
      orderDetails["holdStp"] = `Yes`;
    } else {
      orderDetails["holdStp"] = `No`;
    }

    let stpAggStr: string = "-";
    if (OrderTypeHelper.canSTPAggregate(orderData)) {
      let stpAgg: boolean = orderData.stpAggregationEnabled;
      stpAggStr = stpAgg === true ? `Yes` : `No`;
    }

    if (
      OrderTypeHelper.isStop(orderData.requestedOrderType) ||
      orderData.requestedOrderType === CubiqTS.RequestOrderType.TP
    ) {
      orderDetails["stpAggregationEnabled"] = stpAggStr;
    }

    if (orderData.comments1) {
      orderDetails["clientCommentText"] = orderData.comments1;
    }

    if (orderData.comments2) {
      orderDetails["privateCommentText"] = orderData.comments2;
    }

    if (orderData.salesMargin) {
      // in pips
      orderDetails["markup"] = this.myDealtPricingService.getDealtMarginFormattedDecs(orderData);
    }

    try {
      orderDetails["entryMarkup"] = this.myDealtPricingService.getEntryMarkup(orderData);
    } catch (e) {
      logger.out.error("Failed to read entry markup in order details: " + e);
    }

    if (orderData.hasOwnProperty("allocationData")) {
      orderDetails["entryMarkup"] = this.myDealtPricingService.getEntryMarkup(orderData);
    }

    orderDetails["spotTracking"] =
      this.myDealtPricingService.getDealtFormatedSpotTracking(orderData);

    orderDetails["execChannel"] =
      CubiqTS.ExecutionType[orderData[COLUMN_ORDER_EXECUTION_CHANNEL]] != null
        ? this.translateService.instant(
            "column.filter.executionType." +
              CubiqTS.ExecutionType[orderData[COLUMN_ORDER_EXECUTION_CHANNEL]],
          )
        : EMPTY_RATE_STRING;

    if (orderData.isAutoEligible == null) {
      orderDetails["autoEligible"] = EMPTY_RATE_STRING;
    } else if (typeof orderData.isAutoEligible === "boolean" && orderData.isAutoEligible) {
      orderDetails["autoEligible"] = `Yes`;
    } else {
      orderDetails["autoEligible"] = `No`;
    }

    // dealt
    orderDetails["side"] = this.trackingSideAdapter.retrieveData(
      orderData,
      COLUMN_ORDER_MONITORING_SIDE,
    );

    if (
      orderData.trailingStopDetails &&
      (CubiqTS.RequestOrderType.TSL === orderData.requestedOrderType ||
        CubiqTS.RequestOrderType.TSL_ASK === orderData.requestedOrderType ||
        CubiqTS.RequestOrderType.TSL_BID === orderData.requestedOrderType)
    ) {
      let tslDetails = orderData.trailingStopDetails as CubiqTS.TrailingStopDetailsImpl;

      orderDetails["monitoringTsl"] = true;

      // if (!orderData.isInvertedOrderFg && tslDetails.trailingDistancePts) {
      //   orderDetails["tslPips"] = tslDetails.trailingDistancePts.toString();
      // } else if (tslDetails.invertTrailingDistancePts) {
      //   orderDetails["tslPips"] = tslDetails.invertTrailingDistancePts.toString();
      // }
      if (CubiqTS.BigNumber.isBigNumber(tslDetails?.trailingDistancePts)) {
        orderDetails["tslPips"] = tslDetails.trailingDistancePts.toString();
      }

      if (CubiqTS.BigNumber.isBigNumber(tslDetails?.trailingRt)) {
        orderDetails["tslTracking"] = tslDetails.trailingRt.toString();
      }

      if (CubiqTS.BigNumber.isBigNumber(tslDetails?.initialTrailingRt)) {
        orderDetails["tslStartTracking"] = tslDetails.initialTrailingRt.toString();
      }

      orderDetails["tslOrigRequestRt"] =
        this.myDealtPricingService.getTslOrderOrigTrackingRt(orderData);
    } else {
      orderDetails["monitoringTsl"] = false;
    }

    if (orderData.rateSourceCd) {
      orderDetails["rateSource"] = this.rateSourceAdapter.retrieveData(
        orderData,
        COLUMN_RATE_SOURCE_CODE,
      );
    } else {
      orderDetails["rateSource"] = EMPTY_RATE_STRING;
    }

    if (orderData.tradesCount) {
      orderDetails["tradesCount"] = orderData.tradesCount.toNumber();
    }

    if (orderData.allocationData) {
      let adaptedAllocationData: Array<any> = [];
      let isInvert: boolean = orderData.isInvertedOrderFg;

      let hasComponent: boolean = orderData.allocationData.some(
        (component) => component.componentAllocations !== null,
      );

      if (hasComponent === false && orderData.allocationData.length > 1) {
        adaptedAllocationData = orderData.allocationData.map((allocation) =>
          this.adaptAllocationData(allocation, orderData, isInvert, true),
        );
      } else {
        orderData.allocationData.forEach((allocation: any) => {
          let allocationData = this.adaptAllocationData(allocation, orderData, isInvert, true); // wantd it treated as an alloc, not an order

          if (hasComponent) {
            adaptedAllocationData.push(allocationData);

            let sortedAllocation = this.sortComponentAllocations(allocation, isInvert);

            sortedAllocation.componentAllocations.forEach((compAllocation: any) => {
              adaptedAllocationData.push(
                this.adaptAllocationData(compAllocation, orderData, isInvert, true),
              );
            });
          } else if (orderData.allocationData.length > 1) {
            adaptedAllocationData = allocationData.map((allocation) =>
              this.adaptAllocationData(allocation, orderData, isInvert, true),
            );
          } else {
            // Place root allocation first
            adaptedAllocationData.unshift(allocationData);
          }
        });
      }

      orderDetails["currencyPairIds"] = this.adaptCcyPairIds(adaptedAllocationData, isInvert);
      orderDetails["allocationsCount"] = orderData.allocationData.length;
      orderDetails["allocationData"] = adaptedAllocationData;
    }

    if (orderData.autoForwardPricingFg != null) {
      if (orderData.autoForwardPricingFg) {
        orderDetails["autoForwardPricing"] = `Yes`;
      } else {
        orderDetails["autoForwardPricing"] = `No`;
      }
    }

    orderDetails["nettingId"] = orderData.nettingId;
    orderDetails["fwdNettingId"] = orderData.fwdNettingId;
    orderDetails["reqQuoteId"] = orderData.reqQuoteId;

    if (orderData.customValues) {
      orderDetails["customValues"] = orderData.customValues;
    }

    // title
    // ${this.dealtCcyAdapter.retrieveData(orderData, COLUMN_DEALT_CURRENCY)}
    orderDetails["title"] =
      `Order Details - <span class="order__details__title__order_id">${BfxConfigIDRefHelper.getOrderRef(
        orderDetails,
      )}</span> -
                              <span class="order__details__title__client_id">${
                                orderDetails.clientId
                              }</span>
                              <span class="order__details__title__instrument">${
                                orderDetails.instrument
                              }</span>
                              <span class="order__details__title__dir">${orderDetails.dir}</span>
                              <span class="order__details__title__order_amt__dealt_ccy">${
                                orderDetails.orderAmt
                              }</span>
                              <span class="order__details__title__request_rt" *ngIf="${
                                orderDetails.requestRt
                              }>${orderDetails.requestRt}</span>
                              <span class="order__details__title__type">${orderDetails.type}</span>
                              <span class="order__details__title__date" *ngIf="${
                                orderDetails.valueDt
                              } && ${
                                orderDetails.product == CubiqTS.Product[CubiqTS.Product.NDF]
                              }">${orderDetails.valueDt}</span>`;

    let requestRef = `__bfx-order-details_${this.adaptedCount}_${orderData.orderId.toString()}`;

    orderDetails["__bfx_order_details_request_ref"] = requestRef;

    this.adaptedMap.set(requestRef, orderData);

    if (this.orderIdRequestRefMap.has(orderData.orderId.toString())) {
      let requestRefSet = this.orderIdRequestRefMap.get(orderData.orderId.toString());
      requestRefSet.push(requestRef);
      this.orderIdRequestRefMap.set(orderData.orderId.toString(), requestRefSet);
    } else {
      this.orderIdRequestRefMap.set(orderData.orderId.toString(), [requestRef]);
    }

    return orderDetails;
  }

  private resolveMarketTimeConstToDisplay(marketTimeName: string): string {
    let marketTimeConstItem: CubiqTS.MarketTimeConstantImpl =
      this.marketTimeLookup.getMarketTime(marketTimeName);
    if (marketTimeConstItem != null) {
      let result = null;
      let timeValue = CubiqTS.moment(marketTimeConstItem.constantTime.low, "HH:mm").format("HH:mm");
      let timezoneValue = marketTimeConstItem.timeZoneCd;

      // set system configured date
      if (
        marketTimeConstItem.constantDate != null &&
        marketTimeConstItem.constantTime.low != null
      ) {
        let dateValue = CubiqTS.moment(marketTimeConstItem.constantDate).format(DATE_FORMAT_SHORT);
        result = [dateValue, timeValue, timezoneValue].join(" ");
      }

      // check if type is DATE or TODAY and set today's date
      if (
        (marketTimeConstItem.constantDate == null &&
          marketTimeConstItem.constantType == CubiqTS.MarketTimeConstantType.DATE) ||
        marketTimeConstItem.constantType == CubiqTS.MarketTimeConstantType.TODAY
      ) {
        let dateValue = CubiqTS.moment().format(DATE_FORMAT_SHORT);
        result = [dateValue, timeValue, timezoneValue].join(" ");
      }

      // check if type is TOMORROW and set tomorrow's date
      if (
        marketTimeConstItem.constantDate == null &&
        marketTimeConstItem.constantType == CubiqTS.MarketTimeConstantType.TOMORROW
      ) {
        let dateValue = CubiqTS.moment().add(1, "d").format(DATE_FORMAT_SHORT);
        result = [dateValue, timeValue, timezoneValue].join(" ");
      }
      return result;
    } else if (marketTimeName === "DAY") {
      let test = 3;
    } else {
      return marketTimeName;
    }
  }

  private adaptAllocationData(
    allocationData: CubiqTS.AllocationDataImpl,
    orderData: CubiqTS.OrderDataImpl,
    isInvert?: boolean,
    isComponentAllocation = false,
  ): any {
    if (allocationData instanceof CubiqTS.AllocationDataImpl) {
      let allocationObject: AllocationInfoDetails = new AllocationInfoDetails();
      let accountObject = this.adaptAllocationAccount(orderData, allocationData);
      let isNotComponent: boolean =
        allocationData.allocationType === CubiqTS.AllocationType.PRIME ||
        allocationData.allocationType === CubiqTS.AllocationType.CROSS;

      const counterCcy =
        allocationData.fixedCcy === allocationData.baseCcy
          ? allocationData.nonbaseCcy
          : allocationData.baseCcy;

      const rawValues = new AllocationInfoRawDetails();
      allocationObject.allocId = allocationData.allocationId.toString();
      allocationObject.rawValues = rawValues;
      allocationObject.isSpot = allocationData.allocationProductCd === CubiqTS.Product.SPT;
      allocationObject.allocationRef = allocationData.allocationRef;
      allocationObject.allocationType = allocationData.allocationType;
      allocationObject.accountCode = accountObject.accountCode;
      allocationObject.accountName = accountObject.accountName;
      allocationObject.instrument = this.adaptAllocationInstrument(allocationData, isInvert);
      allocationObject.dir = this.adaptAllocationIntent(allocationData.allocationIntent);
      allocationObject.dealState = this.adaptAllocationDealState(allocationData, "dealState");
      allocationObject.dealId = this.adaptAllocationFillDetails(allocationData, "dealId").label;
      allocationObject.dealRef = this.adaptAllocationFillDetails(allocationData, "dealRef").label;
      allocationObject.dealtCcy = allocationData.fixedCcy
        ? allocationData.fixedCcy
        : EMPTY_RATE_STRING;
      allocationObject.baseCcy = allocationData.baseCcy;
      allocationObject.nonbaseCcy = allocationData.nonbaseCcy;
      allocationObject.orderAmt = this.getFormattedAmount(
        allocationData.allocationQty,
        allocationData.fixedCcy,
      );

      allocationObject.npvAmt = this.getFormattedAmount(
        allocationData.npvAllocationQty,
        allocationData.fixedCcy,
      );

      allocationObject.npvCounterAmt = this.getFormattedAmount(
        allocationData.npvSettleQty,
        counterCcy,
      );

      rawValues.orderAmt = allocationData.allocationQty;
      rawValues.npvAmt = allocationData.npvAllocationQty;
      rawValues.npvCounterAmt = allocationData.npvSettleQty;

      let fillValue: { value: any; label: string };

      fillValue = this.adaptAllocationFillDetails(allocationData, "marketFillSptRt");
      allocationObject.marketSpot = fillValue.label;
      rawValues.marketSpot = fillValue.value;

      fillValue = this.adaptAllocationFillDetails(allocationData, "marketFillPts");
      allocationObject.marketPts = fillValue.label;
      rawValues.marketPts = fillValue.value;

      fillValue = this.adaptAllocationFillDetails(allocationData, "marketFillAllInRt");
      allocationObject.marketAllIn = fillValue.label;
      rawValues.marketAllIn = fillValue.value;

      fillValue = this.adaptAllocationFillDetails(allocationData, "clientFillSptRt");
      allocationObject.clientSpot = fillValue.label;
      rawValues.clientSpot = fillValue.value;

      fillValue = this.adaptAllocationFillDetails(allocationData, "clientFillPts");
      allocationObject.clientPts = fillValue.label;
      rawValues.clientPts = fillValue.value;

      fillValue = this.adaptAllocationFillDetails(allocationData, "clientFillAllInRt");
      allocationObject.clientAllIn = fillValue.label;
      rawValues.clientAllIn = fillValue.value;

      allocationObject.counterAmt = this.getFormattedAmount(allocationData.settleQty, counterCcy);
      rawValues.counterAmt = allocationData.settleQty;

      let formattedMarkup: IFormattedMarkup;
      if (isNotComponent) {
        formattedMarkup = this.adaptAllocationMarkupValue(orderData, allocationData);
      } else {
        formattedMarkup = { numValue: null, textValue: null };
      }
      allocationObject.markup = formattedMarkup.textValue;
      rawValues.markup = formattedMarkup.numValue;

      fillValue = this.adaptAllocationFillDetails(allocationData, "fillDts");
      allocationObject.fillDate = fillValue.label;
      rawValues.fillDate = fillValue.value;

      allocationObject.valueDt = this.adaptAllocationValueDt(
        allocationData.settleDate,
        allocationData.settleTenor,
      );
      rawValues.valueDt = allocationData.settleDate;

      allocationObject.traderGroup = this.adaptTraderGroup(orderData, allocationData);
      allocationObject.reqFwdPoints = allocationData.reqFwdPoints?.toFixed() ?? null;
      rawValues.reqFwdPoints = allocationData.reqFwdPoints;

      return allocationObject;
    } else {
      return null;
    }
  }

  /**
   * Foramt amount according to the currency settings
   *
   * @param amount
   * @param ccyCode
   * @returns
   */
  private getFormattedAmount(amount: BigNumber, ccyCode: string): string {
    if (amount) {
      let precision: number = 0;

      const ccy = this.ccyLookupService.getCcy(ccyCode);
      if (ccy && amount.decimalPlaces() != 0) {
        precision = ccy.minorUnitsQty.toNumber();
      }
      return amount.toFormat(precision);
    }

    return EMPTY_RATE_STRING;
  }

  private adaptAllocationMarkupValue(
    orderData: CubiqTS.OrderDataImpl,
    allocation: CubiqTS.AllocationDataImpl,
  ): IFormattedMarkup {
    if (
      orderData.orderState === CubiqTS.OrderState.FILLED ||
      orderData.orderState === CubiqTS.OrderState.PENDING_FWDS
    ) {
      return this.myDealtPricingService.getDealtAllocationMarkup(allocation, orderData);
    } else {
      return this.myDealtPricingService.getEntryAllocationMarkup(allocation, true, orderData);
    }
  }

  private adaptTraderGroup(
    orderData: CubiqTS.OrderDataImpl,
    allocation: CubiqTS.AllocationDataImpl = null,
  ): string {
    if (
      orderData.orderType === CubiqTS.OrderType.BENCHMARK &&
      (orderData.orderState != CubiqTS.OrderState.SAVED || orderData.deskId == null)
    ) {
      let data: any = { data: orderData };
      if (allocation != null) {
        let singleAllocationOrderData: CubiqTS.OrderDataImpl = Object.assign(
          new CubiqTS.OrderDataImpl(),
          orderData,
        );
        singleAllocationOrderData.allocationData = [allocation];
        data = { data: singleAllocationOrderData };
      }
      return this.bmTraderGroupNameHelper.getTraderGroupNames(data);
    }

    if (orderData.deskId != null) {
      let traderGroup: CubiqTS.TradingGroupImpl = this.traderGroupLookup.getTraderGroup(
        orderData.deskId,
      );
      if (traderGroup != null) {
        return traderGroup.groupCode;
      }
    }
    return EMPTY_RATE_STRING;
  }

  private adaptAllocationFillDetails(
    allocation: CubiqTS.AllocationDataImpl,
    columnProperty: keyof CubiqTS.LastFillDetails,
  ): { value: any; label: string } {
    const detail: CubiqTS.LastFillDetails = allocation?.fillDetails;
    if (detail instanceof CubiqTS.LastFillDetailsImpl && detail.hasOwnProperty(columnProperty)) {
      const colValue = detail[columnProperty];
      if (CubiqTS.moment.isMoment(colValue) && colValue.isValid()) {
        return { value: colValue, label: CubiqTS.moment(colValue).format(DATE_TIME_FORMAT) };
      } else if (colValue instanceof CubiqTS.BigNumber) {
        return { value: colValue, label: colValue.toFixed() };
      } else {
        return { value: colValue, label: colValue?.toString() };
      }
    }
    return { label: null, value: null };
  }

  private adaptAllocationDealState(
    allocationData: CubiqTS.AllocationDataImpl,
    columnProperty: string,
  ): string {
    let status: number = -1;
    let data = "";

    if (allocationData !== null && allocationData.fillDetails != null) {
      status = allocationData.fillDetails[columnProperty];
    } else {
      return EMPTY_RATE_STRING;
    }

    switch (status) {
      case CubiqTS.OrderDealState.ACTIVE:
        return (data = this.translateService.instant("OrderDealState.ACTIVE"));
      case CubiqTS.OrderDealState.FILL_ERROR:
        return (data = this.translateService.instant("OrderDealState.FILL_ERROR"));
      case CubiqTS.OrderDealState.COMPLETED:
        return (data = this.translateService.instant("OrderDealState.COMPLETED"));
      case CubiqTS.OrderDealState.CANCELLED:
        return (data = this.translateService.instant("OrderDealState.CANCELLED"));
      case CubiqTS.OrderDealState.ACK_TIME_OUT:
        return (data = this.translateService.instant("OrderDealState.ACK_TIME_OUT"));
      case CubiqTS.OrderDealState.NAK:
        return (data = this.translateService.instant("OrderDealState.NAK"));
      case CubiqTS.OrderDealState.DONE_NO_STP:
        return (data = this.translateService.instant("OrderDealState.DONE_NO_STP"));
      case CubiqTS.OrderDealState.STP_HOLD:
        return (data = this.translateService.instant("OrderDealState.STP_HOLD"));
      default:
        return (data = EMPTY_RATE_STRING);
    }
  }

  private adaptAllocationAccount(
    orderData?: CubiqTS.OrderDataImpl,
    allocationData?: CubiqTS.AllocationDataImpl,
  ): any {
    let accountLookup = this.accountLookupService.getAccount(orderData.accountCode);
    let accountData = {};

    if (
      allocationData != null &&
      orderData.allocationData != null &&
      orderData.allocationData.length > 1
    ) {
      accountLookup = this.accountLookupService.getAccount(allocationData.accountCode);
    }

    if (accountLookup != null) {
      accountData["accountCode"] = accountLookup.id;
      accountData["accountName"] = accountLookup.name;
      return accountData;
    }

    return EMPTY_RATE_STRING;
  }

  private adaptAllocationValueDt(date: CubiqTS.Moment, tenor: CubiqTS.Tenor): string {
    let tenorValue: string =
      tenor !== null && tenor !== undefined ? this.tenorAdapter.getTenorStr(tenor) : null;
    let dateValue: string = date ? CubiqTS.moment.utc(date).format("DD-MMM-YY") : null;
    if (tenorValue || dateValue) {
      if (tenorValue && dateValue) {
        return `${tenorValue} (${dateValue})`;
      } else {
        return tenorValue ?? dateValue;
      }
    }
    return EMPTY_RATE_STRING;
  }

  private adaptAllocationIntent(intent: CubiqTS.OrderIntent): string {
    if (intent === CubiqTS.OrderIntent.BUY) {
      return this.translateService.instant("column.filter.clientIntent.BUY");
    } else if (intent === CubiqTS.OrderIntent.SELL) {
      return this.translateService.instant("column.filter.clientIntent.SELL");
    }
  }

  private adaptAllocationInstrument(
    allocationData: CubiqTS.AllocationDataImpl,
    isInvert: boolean,
  ): string {
    if (allocationData) {
      if (isInvert && allocationData.allocationType === CubiqTS.AllocationType.CROSS) {
        return allocationData.nonbaseCcy + allocationData.baseCcy;
      } else {
        return allocationData.baseCcy + allocationData.nonbaseCcy;
      }
    }
    return EMPTY_RATE_STRING;
  }

  private adaptCcyPairIds(allocationData: any, isInvert: boolean): Set<string> {
    let currencyPairs: Set<string> = new Set<string>();
    if (allocationData) {
      allocationData.forEach((allocation) => {
        if (isInvert && allocation.allocationType === CubiqTS.AllocationType.CROSS) {
          currencyPairs.add(allocation.nonbaseCcy + allocation.baseCcy);
        } else {
          currencyPairs.add(allocation.baseCcy + allocation.nonbaseCcy);
        }
      });
    }
    return currencyPairs;
  }

  private sortComponentAllocations(
    allocationData: CubiqTS.AllocationDataImpl,
    isInvert: boolean,
  ): any {
    let crossBaseCcy = isInvert ? allocationData.nonbaseCcy : allocationData.baseCcy;
    let componentAllocationToBeChecked = allocationData.componentAllocations[1];
    if (
      componentAllocationToBeChecked.baseCcy === crossBaseCcy ||
      componentAllocationToBeChecked.nonbaseCcy === crossBaseCcy
    ) {
      allocationData.componentAllocations.splice(1, 1);
      allocationData.componentAllocations.splice(0, 0, componentAllocationToBeChecked);
    }

    return allocationData;
  }

  private createClientContactObject(clientContact: CubiqTS.ClientContactImpl): any {
    let contactObject: any = {};

    contactObject.clientCd = clientContact.clientCd;
    contactObject.contactNameTxt = clientContact.contactNameTxt;
    contactObject.deskTxt = clientContact.deskTxt;
    contactObject.mobileTxt = clientContact.mobileTxt;
    contactObject.smsTxt = clientContact.smsTxt;
    contactObject.emailTxt = clientContact.emailTxt;
    contactObject.notifyEntry = clientContact.notifyEntry;
    contactObject.notifyExpiry = clientContact.notifyExpiry;
    contactObject.notifyFill = clientContact.notifyFill;
    contactObject.notifyModify = clientContact.notifyModify;
    contactObject.notifyCancel = clientContact.notifyCancel;
    contactObject.isDefaultFg = clientContact.isDefaultFg;

    return contactObject;
  }

  private parseGammaData(rungs: Array<CubiqTS.OrderDataImpl>, requestedId: string): any {
    // Sort all rungs inline
    rungs = rungs.sort((order1: CubiqTS.OrderDataImpl, order2: CubiqTS.OrderDataImpl) =>
      order2.requestRt.comparedTo(order1.requestRt),
    );
    rungs = rungs.map((rung) => this.orderDataPrivatizationService.checkPrivatization(rung));

    const firstOrder = rungs[0];
    firstOrder.strategyType = CubiqTS.StrategyType.GAMMA; // Need to set this manually - will be required for context menu checks
    firstOrder.siblingRelationship =
      this.siblingRelationshipManager.createDetailRelationship(rungs);
    let orderDetails = this.parseOrderDetails(firstOrder, firstOrder);

    orderDetails.siblingRelationship = firstOrder.siblingRelationship;
    let orderDetailsMap = new Map();
    orderDetailsMap.set(requestedId, orderDetails);

    return {
      strategyType: CubiqTS.StrategyType.GAMMA,
      orderDetails: orderDetailsMap,
      strategyData: null,
      gammaRungs: rungs,
    };
  }

  private parseStrategyData(rootOrderData: CubiqTS.OrderDataImpl): any {
    let orderDetailsMap = new Map();
    let orderMap = new Map(); // key:x#y# value:d
    let childLinks = []; // y ... y + 1
    let siblingLinks = []; // x ... x + 1
    let visitorPaths = []; // set
    let width = 0;
    let height = 0;
    let maxX = 0;
    let maxY = 0;
    let pricingService = this.myDealtPricingService;
    let service = this;

    function adaptOrderDataImpl(this: void, order: CubiqTS.OrderDataImpl, d: StrategyData) {
      let orderDetails = service.parseOrderDetails(order, rootOrderData);
      orderDetailsMap.set(orderDetails.orderId, orderDetails);

      d.label = "";
      d.id = order.orderId.toString();

      if (CubiqTS.RequestOrderType.CALL === order.requestedOrderType) {
        // A call will preempt clientIntent
        let labelType =
          order.executionType == CubiqTS.ExecutionType.MANUAL
            ? service.sysConfigUtilService.manualExecutionCallNameText
            : "CALL ";
        d.label += labelType;
      } else if (CubiqTS.OrderIntent.BUY === order.clientIntent) {
        d.label += "B ";
      } else if (CubiqTS.OrderIntent.SELL === order.clientIntent) {
        d.label += "S ";
      }

      if (order.requestedOrderType == Object(order.requestedOrderType)) {
        if (order.requestedOrderType === CubiqTS.RequestOrderType.TP) {
          d.label += "TP";
        } else if (
          order.requestedOrderType === CubiqTS.RequestOrderType.SL_ATRATE ||
          order.requestedOrderType === CubiqTS.RequestOrderType.SL_BID ||
          order.requestedOrderType === CubiqTS.RequestOrderType.SL_ASK
        ) {
          d.label += "SL";
        } else if (
          order.requestedOrderType === CubiqTS.RequestOrderType.TSL ||
          order.requestedOrderType === CubiqTS.RequestOrderType.TSL_BID ||
          order.requestedOrderType === CubiqTS.RequestOrderType.TSL_ASK
        ) {
          d.label += "TSL";
        } else if (order.requestedOrderType === CubiqTS.RequestOrderType.MARKET) {
          d.label += "MKT ";
          if (
            typeof order.baseCode === "string" &&
            order.baseCode.length === 3 &&
            typeof order.nonBaseCode === "string" &&
            order.nonBaseCode.length === 3
          ) {
            if (order.isInvertedOrderFg) {
              d.label += order.nonBaseCode + order.baseCode + " ";
            } else {
              d.label += order.baseCode + order.nonBaseCode + " ";
            }
          }
        }
      }

      if (order.requestedOrderType !== CubiqTS.RequestOrderType.MARKET && order.requestRt != null) {
        d.label += " " + pricingService.getOrderRequestRt(order) + " ";
      }

      if (Array.isArray(order.childRelationships)) {
        let iOcoSkip = -1;
        d.childRelationshipTypes = order.childRelationships
          .filter((relationship: CubiqTS.Relationship, i) => {
            if (i == iOcoSkip) return false;

            if (
              order.childRelationships[i].order.siblingRelationship &&
              CubiqTS.OrderRelationshipType.OCO ===
                order.childRelationships[i].order.siblingRelationship.relationshipType
            ) {
              iOcoSkip = i + 1;
            }

            return true;
          })
          .map((relationship: CubiqTS.Relationship) => {
            return relationship.relationshipType;
          });
      }

      if (order.siblingRelationship === Object(order.siblingRelationship)) {
        d.siblingRelationshipType = order.siblingRelationship.relationshipType;
      }
    }

    function adaptOrderRequestDataImpl(
      this: void,
      orderRequest: CubiqTS.OrderRequestDataImpl,
      d: StrategyData,
    ) {
      d.label = "";
      d.id = orderRequest.orderId.toString();

      if (CubiqTS.RequestOrderType.CALL === orderRequest.requestOrderType) {
        // A call will preempt clientIntent
        d.label += "CALL ";
      } else if (CubiqTS.OrderIntent.BUY === orderRequest.clientIntent) {
        d.label += "B ";
      } else if (CubiqTS.OrderIntent.SELL === orderRequest.clientIntent) {
        d.label += "S ";
      } else {
        console.debug("Failed to parse client intent");
      }

      if (
        orderRequest.requestOrderType !== CubiqTS.RequestOrderType.MARKET &&
        orderRequest.requestRate != null
      ) {
        // TODO string? already formated?
        d.label += "@ " + orderRequest.requestRate + " ";
      }

      if (orderRequest.requestOrderType == Object(orderRequest.requestOrderType)) {
        if (orderRequest.requestOrderType === CubiqTS.RequestOrderType.TP) {
          d.label += "TP";
        } else if (
          orderRequest.requestOrderType === CubiqTS.RequestOrderType.SL_ATRATE ||
          orderRequest.requestOrderType === CubiqTS.RequestOrderType.SL_BID ||
          orderRequest.requestOrderType === CubiqTS.RequestOrderType.SL_ASK
        ) {
          d.label += "SL";
        } else if (
          orderRequest.requestOrderType === CubiqTS.RequestOrderType.TSL ||
          orderRequest.requestOrderType === CubiqTS.RequestOrderType.TSL_BID ||
          orderRequest.requestOrderType === CubiqTS.RequestOrderType.TSL_ASK
        ) {
          d.label += "TSL";
        } else if (orderRequest.requestOrderType === CubiqTS.RequestOrderType.MARKET) {
          d.label += "MKT ";
        }
      }

      if (Array.isArray(orderRequest.childRelationships)) {
        d.childRelationshipTypes = orderRequest.childRelationships.map(
          (relationship: CubiqTS.LinkedRelationshipImpl) => {
            return relationship.relationshipType;
          },
        );
      }

      if (orderRequest.sibling === Object(orderRequest.sibling)) {
        d.siblingRelationshipType = orderRequest.sibling.relationshipType;
      }
    }

    function handleOrder(
      this: void,
      order: CubiqTS.OrderDataImpl | CubiqTS.LinkedOrderRequestImpl | CubiqTS.OrderRequestDataImpl,
      d: StrategyData,
      x,
      y,
      oX,
      oY,
      childIndex?,
    ) {
      if (order instanceof CubiqTS.OrderDataImpl) {
        adaptOrderDataImpl(order, d);
      }

      d.x = x;
      d.y = y;

      if (oX === undefined || oX === null) {
        oX = -1;
      }

      if (oY === undefined || oY === null) {
        oY = -1;
      }

      // track for translation
      maxX = Math.max(maxX, x);
      maxY = Math.max(maxY, y);

      // check for link to sibling
      if (childIndex === undefined) {
        let siblingLink = handleBacklink("x" + oX + "y" + oY, d, "SIBLING");
        if (siblingLink !== null) {
          siblingLinks.push(siblingLink);
        }
      } else {
        // check for link to parent
        let childLink = handleBacklink("x" + oX + "y" + oY, d, "CHILD", childIndex);
        if (childLink !== null) {
          childLinks.push(childLink);
        }
      }

      // track for d3 data() & scaling (can't scale yet!)
      if (orderMap.has("x" + x + "y" + y)) {
        throw new Error("Node Collsion");
      }

      orderMap.set("x" + x + "y" + y, d);
    }

    function handleBacklink(this: void, key, d: StrategyData, type, index?) {
      let source: StrategyData = orderMap.get(key);
      if (source !== undefined && source !== null) {
        d.visitorPath = source.visitorPath.slice();

        let expiryIndex = source.visitorPath[source.visitorPath.length - 1].expiryIndex;

        if (index === undefined) {
          d.visitorPath.push({
            type: type,
            /* pathType - refactor or add isSibling/isChild to enum? */
            orderRelationshipType: source.siblingRelationshipType,
            expiryIndex: expiryIndex,
            sourceId: source.id,
            rootId: d.visitorPath[0].rootId,
            targetId: d.id,
          });
        } else {
          d.childIndex = index;

          if (source.childRelationshipTypes[index] === CubiqTS.OrderRelationshipType.ON_TIMEOUT) {
            expiryIndex++;
          }

          let pathElement = {
            type: type,
            index: index,
            orderRelationshipType: source.childRelationshipTypes[index],
            expiryIndex: expiryIndex,
            rootId: d.visitorPath[0].rootId,
            sourceId: source.id,
            targetId: d.id,
          };
          d.visitorPath.push(pathElement);
        }

        return { source: source, target: d };
      } else {
        // track for tree
        d.visitorPath = [
          {
            type: "ROOT",
            orderRelationshipType: CubiqTS.OrderRelationshipType.NONE,
            expiryIndex: 0,
            rootId: d.id,
            sourceId: d.id,
            targetId: d.id,
          },
        ];
      }

      return null;
    }

    function traverseChildOrders(
      this: void,
      childRelationships: CubiqTS.Relationship[],
      nextX,
      nextY,
      oX,
      oY,
    ) {
      let maxNextX = nextX;
      let i = 0;
      let skipCounter = 0;

      while (i < childRelationships.length) {
        let currentOrder = childRelationships[i].order;
        let currentNextX = traverseOrder(
          currentOrder,
          new StrategyData(),
          maxNextX,
          nextY,
          oX,
          oY,
          i - skipCounter,
        );
        maxNextX = Math.max(maxNextX, currentNextX);

        if (
          currentOrder.siblingRelationship == Object(currentOrder.siblingRelationship) &&
          CubiqTS.OrderRelationshipType.OCO == currentOrder.siblingRelationship.relationshipType
        ) {
          // skip second OCO child in model.
          i++; // causes invalid childRelationship index if multiple children with OCO, hence skipIndex adjustment (OMS-33804)
          skipCounter++;
        }

        i++;
      }

      return maxNextX;
    }

    function traverseSiblingOrder(
      this: void,
      order: CubiqTS.OrderDataImpl,
      d: StrategyData,
      x,
      y,
      oX,
      oY,
    ) {
      handleOrder(order, d, x, y, oX, oY);

      let nextX = x + 1;
      let nextY = y + 1;

      // check if sibling has any children
      if (Array.isArray(order.childRelationships) && order.childRelationships.length > 0) {
        let currentNextX = traverseChildOrders(order.childRelationships, x, nextY, x, y);

        nextX = Math.max(nextX, currentNextX);
      } else {
        // edge detected
        visitorPaths.push(d.visitorPath);
      }

      return nextX;
    }

    function traverseOrder(
      this: void,
      order: CubiqTS.OrderDataImpl,
      d: StrategyData,
      x,
      y,
      oX?,
      oY?,
      childIndex?,
    ) {
      handleOrder(order, d, x, y, oX, oY, childIndex);

      let nextX = x + 1;
      let nextY = y + 1;

      if (Array.isArray(order.childRelationships) && order.childRelationships.length > 0) {
        nextX = traverseChildOrders(order.childRelationships, x, nextY, x, y);
      }

      let siblingRelationshipType = null;

      if (order.siblingRelationship === Object(order.siblingRelationship)) {
        nextX = traverseSiblingOrder(
          order.siblingRelationship.order,
          new StrategyData(),
          nextX,
          y,
          x,
          y,
        );
      }

      if (
        (d.childRelationshipTypes !== Object(d.childRelationshipTypes) ||
          d.childRelationshipTypes.length === 0) &&
        d.siblingRelationshipType === null
      ) {
        // edge detected
        visitorPaths.push(d.visitorPath);
      }

      return nextX;
    }

    traverseOrder(rootOrderData, new StrategyData(), 0, 0);

    let strategyData = {
      nodes: Array.from(orderMap.values()),
      childLinks: childLinks,
      siblingLinks: siblingLinks,
      visitorPaths: visitorPaths,
      width: width,
      height: height,
      maxX: maxX,
      maxY: maxY,
    };

    return {
      strategyType: CubiqTS.StrategyType.STANDARD,
      orderDetails: orderDetailsMap,
      strategyData: strategyData,
    };
  }

  public releaseMediatedOrderDetails(requestRef: string): Promise<void> {
    return new Promise<void>((res, rej) => {
      if (this.adaptedMap.has(requestRef)) {
        let orderData = this.adaptedMap.get(requestRef);

        if (orderData) {
          let orderId: string = orderData.orderId.toString();
          let requestRefs = this.orderIdRequestRefMap.get(orderId);

          if (Array.isArray(requestRefs)) {
            let index = requestRefs.indexOf(requestRef);
            if (index > 0) requestRefs.splice(index, 1);

            if (requestRefs.length == 0) this.orderIdRequestRefMap.delete(orderId);
          }
        }
      }
      this.adaptedMap.delete(requestRef);

      res();
    });
  }

  public getMediatedOrderData(
    orderId: string,
    requestRef: string | null = null,
  ): Promise<CubiqTS.OrderDataImpl> {
    return new Promise<CubiqTS.OrderDataImpl>((res, rej) => {
      if (!requestRef && this.orderIdRequestRefMap.has(orderId)) {
        let requestRefs = this.orderIdRequestRefMap.get(orderId);
        if (Array.isArray(requestRefs) && requestRefs.length > 0) {
          requestRef = requestRefs[requestRefs.length - 1];
        }
        if (requestRef && this.adaptedMap.has(requestRef)) {
          res(this.adaptedMap.get(requestRef));
        } else {
          rej(null);
        }
      } else if (!this.orderIdRequestRefMap.has(orderId)) {
        this.requestMediatedOrderDetails(orderId).then((value) => {
          if (value) {
            let requestRefs = this.orderIdRequestRefMap.get(orderId);
            if (Array.isArray(requestRefs) && requestRefs.length > 0) {
              requestRef = requestRefs[requestRefs.length - 1];
            }
            if (requestRef && this.adaptedMap.has(requestRef)) {
              let item = this.adaptedMap.get(requestRef);
              this.releaseMediatedOrderDetails(requestRef);
              res(item);
            } else {
              rej(null);
            }
          } else {
            rej(null);
          }
        });
      } else {
        if (requestRef && this.adaptedMap.has(requestRef)) {
          res(this.adaptedMap.get(requestRef));
        } else {
          rej(null);
        }
      }
    });
  }
}
